import { Component, OnInit } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { CommonModule } from '@angular/common';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from '../../../Services/login.service';
import { MapService } from '../../../Services/map.service';
import { apiEndPoints } from '../../../api/apiEndPoint';

@Component({
  selector: 'app-dumpyard-location',
  standalone: true,
  imports: [GoogleMapsModule, CommonModule],
  templateUrl: './dumpyard-location.component.html',
  styleUrls: ['./dumpyard-location.component.css'],
})
export class DumpyardLocationComponent implements OnInit {
  center: google.maps.LatLngLiteral = { lat: 12.9716, lng: 77.5946 }; // Default location
  zoom = 12;

  markerIcon = {
    url: 'assets/Images/map_marker_dumpyard.png',
    scaledSize: new google.maps.Size(70, 50),
  };

  initialCityId: any;
  dumpLocation: any[] = [];
  markers: any[] = [];
  selectedDumpyard: any;
  constructor(
    private loginService: LoginService,
    private mapService: MapService,
    private offcanvasService: NgbOffcanvas
  ) {}

  ngOnInit() {
    this.dumpyardLocation();
  }

  // -------------------------------------- Get Dumpyard Location API -------------------------------------- //

  dumpyardLocation() {
    this.mapService
      .getDumpyardLocation(apiEndPoints.dumpyardLocation)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.dumpLocation = response.body.details;

            this.markers = this.dumpLocation.map((location: any) => ({
              position: {
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.logitude),
              },
              icon: this.markerIcon,
              title: location.companyName || 'Dumpyard',
              orderId: location.orderId,
              data: location,
            }));

            if (this.markers.length > 0) {
              this.center = this.markers[0].position;

              let startZoom = 5;
              const endZoom = 14;
              const stepTime = 50;
              const mapZoomInterval = setInterval(() => {
                if (startZoom < endZoom) {
                  startZoom++;
                  this.zoom = startZoom;
                } else {
                  clearInterval(mapZoomInterval);
                }
              }, stepTime);
            }
          } else {
            console.error('Failed to fetch dumpyard locations:', response);
          }
        },
        error: (error) => {
          console.error('Error fetching dumpyard locations:', error);
        },
      });
  }

  onMarkerClick(marker: any, content: any) {
    this.selectedDumpyard = marker;
    console.log('Clicked Marker Data:', marker);
    this.offcanvasService.open(content, {
      position: 'end',
      backdrop: true,
      panelClass: 'custom-offcanvas',
    });
  }
}
